export const GET_VEHICLES_EXPENSE_PENDING = "GET_VEHICLES_EXPENSE_PENDING";
export const GET_VEHICLES_EXPENSE_SUCCESS = "GET_VEHICLES_EXPENSE_SUCCESS";
export const GET_VEHICLES_EXPENSE_FAILURE = "GET_VEHICLES_EXPENSE_FAILURE";

export const ADD_VEHICLES_EXPENSE_PENDING = "ADD_VEHICLES_EXPENSE_PENDING";
export const ADD_VEHICLES_EXPENSE_SUCCESS = "ADD_VEHICLES_EXPENSE_SUCCESS";
export const ADD_VEHICLES_EXPENSE_FAILURE = "ADD_VEHICLES_EXPENSE_FAILURE";

export const UPLOAD_VEHICLES_EXPENSE_PENDING =
  "UPLOAD_VEHICLES_EXPENSE_PENDING";
export const UPLOAD_VEHICLES_EXPENSE_SUCCESS =
  "UPLOAD_VEHICLES_EXPENSE_SUCCESS";
export const UPLOAD_VEHICLES_EXPENSE_FAILURE =
  "UPLOAD_VEHICLES_EXPENSE_FAILURE";

export const EDIT_VEHICLES_EXPENSE_PENDING = "EDIT_VEHICLES_EXPENSE_PENDING";
export const EDIT_VEHICLES_EXPENSE_SUCCESS = "EDIT_VEHICLES_EXPENSE_SUCCESS";
export const EDIT_VEHICLES_EXPENSE_FAILURE = "EDIT_VEHICLES_EXPENSE_FAILURE";

export const DELETE_VEHICLES_EXPENSE_PENDING =
  "DELETE_VEHICLES_EXPENSE_PENDING";
export const DELETE_VEHICLES_EXPENSE_SUCCESS =
  "DELETE_VEHICLES_EXPENSE_SUCCESS";
export const DELETE_VEHICLES_EXPENSE_FAILURE =
  "DELETE_VEHICLES_EXPENSE_FAILURE";

export const DOWNLOAD_VEHICLES_EXPENSE_PENDING =
  "DOWNLOAD_VEHICLES_EXPENSE_PENDING";
export const DOWNLOAD_VEHICLES_EXPENSE_SUCCESS =
  "DOWNLOAD_VEHICLES_EXPENSE_SUCCESS";
export const DOWNLOAD_VEHICLES_EXPENSE_FAILURE =
  "DOWNLOAD_VEHICLES_EXPENSE_FAILURE";
